import { useLocation } from "react-router-dom";

import { useAppFlags } from "./useAppFlags";

const healthSystemBasedViews = ["/house-view"];
/**
 * Custom hook that determines if the current view is based on a health system.
 * It uses the current location's pathname and checks if it matches any predefined
 * health system-based views. Additionally, it considers whether the new data hierarchy
 * is supported.
 *
 * @returns {boolean} True if the current view is health system-based and the new data hierarchy is supported, otherwise false.
 */
export const useIsHealthSystemBasedView = () => {
  const location = useLocation();
  const { supportingNewDataHierarchy } = useAppFlags();

  return isHealthSystemBasedView(location.pathname, supportingNewDataHierarchy);
};

/**
 * Function that checks if a given pathname corresponds to a health system-based view.
 * It verifies if the pathname starts with any of the predefined health system-based views
 * and if the new data hierarchy is supported.
 *
 * @param {string} pathname - The current location pathname to check.
 * @param {boolean} supportingNewDataHierarchy - Flag indicating if the new data hierarchy is supported.
 * @returns {boolean} True if the pathname is a health system-based view and the new data hierarchy is supported, otherwise false.
 */
export const isHealthSystemBasedView = (pathname: string, supportingNewDataHierarchy: boolean) => {
  return (
    healthSystemBasedViews.some((view) => pathname.startsWith(view)) && supportingNewDataHierarchy
  );
};
